export enum GlobalMyaccountSubscriptionsRoutes {
  BASE = 'myaccount-subscriptions'
}
